import initSlider from '../sliders/initSlider';
import { tabsSliderOptions, tabsContentSliderOptions } from '../sliders/sliders';

document.addEventListener('DOMContentLoaded', (e) => {
  const accountsTabsSlider = initSlider('[data-accounts-tabs-slider]', tabsSliderOptions);
  const accountsSlider = initSlider('[data-accounts-slider]', tabsContentSliderOptions);
});
